import * as React from "react";
export default function CalcReport(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={33}
      height={33}
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={33} height={33} rx={9.9} fill="#27272A" />
      <g clipPath="url(#clip0_95_45)">
        <path
          d="M22.0689 7.42505H10.9314C9.90627 7.42505 9.0752 8.25612 9.0752 9.2813V24.1313C9.0752 25.1565 9.90627 25.9875 10.9314 25.9875H22.0689C23.0941 25.9875 23.9252 25.1565 23.9252 24.1313V9.2813C23.9252 8.25612 23.0941 7.42505 22.0689 7.42505Z"
          stroke="url(#paint0_linear_95_45)"
          strokeWidth={1.85625}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.7876 11.1375H20.2126"
          stroke="url(#paint1_linear_95_45)"
          strokeWidth={1.85625}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.2124 18.5625V22.275"
          stroke="url(#paint2_linear_95_45)"
          strokeWidth={1.85625}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.2124 14.8501H20.2226"
          stroke="url(#paint3_linear_95_45)"
          strokeWidth={1.85625}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5 14.8501H16.5102"
          stroke="url(#paint4_linear_95_45)"
          strokeWidth={1.85625}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.7876 14.8501H12.7978"
          stroke="url(#paint5_linear_95_45)"
          strokeWidth={1.85625}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5 18.5625H16.5102"
          stroke="url(#paint6_linear_95_45)"
          strokeWidth={1.85625}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.7876 18.5625H12.7978"
          stroke="url(#paint7_linear_95_45)"
          strokeWidth={1.85625}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5 22.2749H16.5102"
          stroke="url(#paint8_linear_95_45)"
          strokeWidth={1.85625}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.7876 22.2749H12.7978"
          stroke="url(#paint9_linear_95_45)"
          strokeWidth={1.85625}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_95_45"
          x1={16.5002}
          y1={7.42505}
          x2={16.5002}
          y2={25.9875}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="white" stopOpacity={0.65} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_95_45"
          x1={16.5001}
          y1={11.1375}
          x2={16.5001}
          y2={12.1375}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="white" stopOpacity={0.65} />
        </linearGradient>
        <linearGradient
          id="paint2_linear_95_45"
          x1={20.7124}
          y1={18.5625}
          x2={20.7124}
          y2={22.275}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="white" stopOpacity={0.65} />
        </linearGradient>
        <linearGradient
          id="paint3_linear_95_45"
          x1={20.2175}
          y1={14.8501}
          x2={20.2175}
          y2={15.8501}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="white" stopOpacity={0.65} />
        </linearGradient>
        <linearGradient
          id="paint4_linear_95_45"
          x1={16.5051}
          y1={14.8501}
          x2={16.5051}
          y2={15.8501}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="white" stopOpacity={0.65} />
        </linearGradient>
        <linearGradient
          id="paint5_linear_95_45"
          x1={12.7927}
          y1={14.8501}
          x2={12.7927}
          y2={15.8501}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="white" stopOpacity={0.65} />
        </linearGradient>
        <linearGradient
          id="paint6_linear_95_45"
          x1={16.5051}
          y1={18.5625}
          x2={16.5051}
          y2={19.5625}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="white" stopOpacity={0.65} />
        </linearGradient>
        <linearGradient
          id="paint7_linear_95_45"
          x1={12.7927}
          y1={18.5625}
          x2={12.7927}
          y2={19.5625}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="white" stopOpacity={0.65} />
        </linearGradient>
        <linearGradient
          id="paint8_linear_95_45"
          x1={16.5051}
          y1={22.2749}
          x2={16.5051}
          y2={23.2749}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="white" stopOpacity={0.65} />
        </linearGradient>
        <linearGradient
          id="paint9_linear_95_45"
          x1={12.7927}
          y1={22.2749}
          x2={12.7927}
          y2={23.2749}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="white" stopOpacity={0.65} />
        </linearGradient>
        <clipPath id="clip0_95_45">
          <rect
            width={19.8}
            height={19.8}
            fill="white"
            transform="translate(6.6001 6.6001)"
          />
        </clipPath>
      </defs>
    </svg>
    );
}
